function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  transform: "translate(.26 1)"
}, React.createElement("circle", {
  cx: 10.741,
  cy: 10,
  r: 10
}), React.createElement("path", {
  d: "M1.075 9.57c4.891 1.878 16.203 1.254 19.291 0M5.216 2.413c4.618 6.5 2.882 11.66 0 15.5M16.561 2.413c-4.618 6.5-2.882 11.66 0 15.5"
}));

function SvgDribbble(props) {
  return React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 22 22",
    width: "1em"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjIyIiB2aWV3Qm94PSIwIDAgMjIgMjIiIHdpZHRoPSIyMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSguMjYgMSkiPjxjaXJjbGUgY3g9IjEwLjc0MSIgY3k9IjEwIiByPSIxMCIvPjxwYXRoIGQ9Im0xLjA3NTE2OTQxIDkuNTY5NTc5OTRjNC44OTExOTI0NiAxLjg3ODM5NTE2IDE2LjIwMjkyMjE5IDEuMjU0NTUwNDYgMTkuMjkxMjU5NzkgMG0tMTUuMTUwMTIwNjEtNy4xNTY4NjAzNWM0LjYxNzgyMTM5IDYuNSAyLjg4MjE3ODYyIDExLjY2MDY0NDcxIDAgMTUuNTAwMDAwMDEiLz48cGF0aCBkPSJtMTMuNzExOTE0MSAyLjQxMjcxOTU5YzQuNjE3ODIxNCA2LjUgMi44ODIxNzg2IDExLjY2MDY0NDcxIDAgMTUuNTAwMDAwMDEiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDMwLjI3MyAwKSIvPjwvZz48L3N2Zz4=";
export { SvgDribbble as ReactComponent };